import { useContext } from 'react';
import { GeaoContext } from '../../../GeaoContextProvider';

/**
 * Reusable form buttons component for Next and Save And Exit actions
 * @param {Object} props - The component props
 * @param {Function} props.onSaveAndExit - Handler function for Save And Exit button
 * @param {boolean} props.disabled - Whether the buttons should be disabled
 * @param {string} [props.submitButtonText="Next"] - Text for the submit button
 * @param {string} [props.saveExitButtonText="Save And Exit"] - Text for the save and exit button
 * @returns {JSX.Element} The form buttons component
 */
export default function FormButtons({
    onSaveAndExit,
    disabled,
    submitButtonText = "Next",
    saveExitButtonText = "Save And Exit"
}) {
    const { interviewIsCompleted } = useContext(GeaoContext);
    return (
        <div className="margin-top">
            <button
                type="submit"
                className="btn btn--primary btn--full-mobile btn--pull-right"
                disabled={disabled || interviewIsCompleted}
            >
                <span>{submitButtonText}</span>
            </button>

            <button
                type="button"
                className="btn btn--secondary btn--full-mobile btn--pull-right"
                onClick={onSaveAndExit}
                disabled={disabled || interviewIsCompleted}
            >
                <span>{saveExitButtonText}</span>
            </button>
        </div>
    );
}